import Swal from 'sweetalert2';
// import { useNavigate } from 'react-router-dom';

// export const handleUnauthorized = () => {
//   const navigate = useNavigate();
//   localStorage.removeItem("authToken");
//   Swal.fire({
//     icon: "error",
//     title: "Session expired. Please login again.",
//     toast: true,
//     position: "top-end",
//     showConfirmButton: false,
//     timer: 2000,
//   });
//   navigate('/login');
// };

export const handleUnauthorized = (navigate) => {
  localStorage.removeItem("authToken");
  Swal.fire({
    icon: "error",
    title: "Session expired. Please login again.",
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 2000,
  });
  navigate('/sign-in');
};

export const showSuccessMessage = (successmessage) => {
    Swal.fire({
      icon: "success",
      title: `${successmessage}`,
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
    });
  };

export const showErrorMessage = (errormessage) => {
    Swal.fire({
        icon: "error",
        title: `${errormessage}`,
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
      });
};

export const showConfirmationDialog = async (message,confirmmessage='Yes, change it!') => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: `${message}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: `${confirmmessage}`,
      cancelButtonText: "No, keep it",
    });
    return result;
};
